module.exports = __webpack_public_path__ + "img/horizontal_6_2_3.14a732ec.png";